import { forwardRef, useId } from "react"

import { Label } from "./label"
import { ErrorLabel } from "./error-label"
import { cn } from "@/lib/utils";

type TDefaultInputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "prefix" | "type"
>;

type UploadCardProps = TDefaultInputProps & {
  label?: string
  labelDescription?: string
  error?: string
}

export const UploadCard = forwardRef<HTMLInputElement, UploadCardProps>(({ label, error, labelDescription, ...props }, ref) => {
  const id = useId()

  return (
    <div>
      <Label id={id}>{label}</Label>
      <span className="sr-only">{labelDescription}</span>

      <input
        id={id}
        ref={ref}
        type="file"
        className={cn(
          "block w-max text-sm rounded-full text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700",
          "ring-2 ring-offset-2 ring-transparent focus:ring-blue-300 hover:file:bg-blue-100 focus:outline-none "
        )}
        {...props}
      />

      {error && error.length > 1 && <ErrorLabel>{error}</ErrorLabel>}
    </div>
  )
})
